import { render } from "./OtherRolesView.vue?vue&type=template&id=5e10d8bd&scoped=true"
import script from "./OtherRolesView.vue?vue&type=script&lang=js"
export * from "./OtherRolesView.vue?vue&type=script&lang=js"

import "./OtherRolesView.vue?vue&type=style&index=0&id=5e10d8bd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e10d8bd"

export default script